<template>
  <a-drawer :title='title'
            :maskClosable='true'
            width='30%'
            placement='right'
            :closable='true'
            @close='close'
            :visible='visible'
            style='height: 100%;overflow: auto;padding-bottom: 53px;'>
    <a-spin :spinning='confirmLoading'>
      <a-form :form='form' autocomplete="off">
        <mtc-form-item label='label.userAccount' :labelCol='labelCol' :wrapperCol='wrapperCol'>
          <a-input :placeholder="$t('label.pleaseEnterAccount')"
                   autocomplete="off"
                   v-decorator.trim="['username', validatorRules.username]"
                   :readOnly='!!model.id' />
        </mtc-form-item>
        <template v-if='!model.id'>
          <mtc-form-item label='label.loginPassword' :labelCol='labelCol' :wrapperCol='wrapperCol'>
            <a-input type='password' auto-complete="new-password" :placeholder="$t('label.pleaseEnterLoginPassword')" v-decorator="['password', validatorRules.password]" />
          </mtc-form-item>
          <mtc-form-item :label="$t('label.confirmPassword')" :labelCol='labelCol' :wrapperCol='wrapperCol'>
            <a-input type='password'
                     auto-complete="new-password"
                     @blur='handleConfirmBlur'
                     :placeholder="$t('label.pleaseConfirmLoginPassword')"
                     v-decorator="['confirmpassword', validatorRules.confirmpassword]" />
          </mtc-form-item>
        </template>
        <mtc-form-item label='label.userName' :labelCol='labelCol' :wrapperCol='wrapperCol'>
          <mtc-lang-popover :whetherLang="whetherLang('realname')" :popLists="getMainTablePop('realname')">
            <a-input v-decorator="['realname', validatorRules.realname]"
                     :read-only="checkField('realname')"
                     @click="openLangModal('realname', true)"
                     :placeholder="$t('label.pleaseEnterUsername')" />
          </mtc-lang-popover>
        </mtc-form-item>
        <mtc-form-item label='label.employeeID' :labelCol='labelCol' :wrapperCol='wrapperCol'>
          <a-input :placeholder="$t('label.pleaseEnterWorkNumber')" v-decorator.trim="['workNo', validatorRules.workNo]" />
        </mtc-form-item>
        <mtc-form-item label='label.position' :labelCol='labelCol' :wrapperCol='wrapperCol'>
          <j-select-position :placeholder="$t('label.pleaseSelectJobTitle')"
                             :selectButtonText="$t('button.select')"
                             :multiple='false'
                             v-decorator="['post', {}]" />
        </mtc-form-item>
        <mtc-form-item label='label.roleAssignment' :labelCol='labelCol' :wrapperCol='wrapperCol' v-show='!roleDisabled'>
          <a-select mode='multiple'
                    :disabled='departDisabled'
                    showSearch
                    style='width: 100%'
                    :placeholder="$t('label.pleaseSelectUserRole')"
                    optionFilterProp='children'
                    v-model='selectedRole'
                    :getPopupContainer='(target) => target.parentNode'>
            <a-select-option v-for='(role,roleindex) in roleList' :key='roleindex.toString()' :value='role.id'>
              {{ role.roleName }}
            </a-select-option>
          </a-select>
        </mtc-form-item>
        <!--部门分配-->
        <mtc-form-item label='label.departmentAssignment' :labelCol='labelCol' :wrapperCol='wrapperCol'>
          <a-input-search :placeholder="$t('label.clickToSelectDepartment')" v-model='checkedDepartNameString' readOnly @search='onSearch'>
            <a-button slot='enterButton' icon='search'>{{ $t('button.select') }}</a-button>
          </a-input-search>
        </mtc-form-item>
        <!--租户分配-->
        <!-- <mtc-form-item label='label.tenantAssignment' :labelCol='labelCol' :wrapperCol='wrapperCol' v-show='!departDisabled'>
          <a-select mode='multiple'
                    style='width: 100%'
                    :placeholder="$t('label.selectTenantAssignment')"
                    :disabled='disableSubmit'
                    v-model='currentTenant'>
            <a-select-option v-for='(item, index) in tenantList' :key='index' :value='item.id'>
              {{ item.name }}
            </a-select-option>
          </a-select>
        </mtc-form-item>-->
        <mtc-form-item label='label.mainDepartment' :labelCol='labelCol' :wrapperCol='wrapperCol' v-if='belongIdShow == true'>
          <a-select style='width: 100%'
                    :aceholder="$t('label.pleaseSelectMainDepartment')"
                    v-model='belongOrgId'
                    :dropdownStyle="{maxHeight:'200px',overflow:'auto'}">
            <a-select-option v-for='item in BelongDepartOptions' :key='item.key' :value='item.key'>
              {{ item.title }}
            </a-select-option>
          </a-select>
        </mtc-form-item>
        <mtc-form-item label='label.identity' :labelCol='labelCol' :wrapperCol='wrapperCol'>
          <a-radio-group v-model='identity' @change='identityChange'>
            <a-radio value='1'>{{ $t('label.normalUser') }}</a-radio>
            <a-radio value='2'>{{ $t('label.supervisor') }}</a-radio>
          </a-radio-group>
        </mtc-form-item>
        <mtc-form-item label='label.responsibleDepartment' :labelCol='labelCol' :wrapperCol='wrapperCol' v-if='departIdShow == true'>
          <a-select mode='multiple'
                    style='width: 100%'
                    :aceholder="$t('label.pleaseSelectDepartmentInCharge')"
                    v-model='departIds'
                    optionFilterProp='children'
                    :getPopupContainer='(target) => target.parentNode'
                    :dropdownStyle="{maxHeight:'200px',overflow:'auto'}">
            <a-select-option v-for='item in resultDepartOptions' :key='item.key' :value='item.key'>
              {{ item.title }}
            </a-select-option>
          </a-select>
        </mtc-form-item>
        <!-- update--end--autor:wangshuai-----date:20200108------for：新增身份和负责部门------ -->
        <mtc-form-item label='label.image' :labelCol='labelCol' :wrapperCol='wrapperCol'>
          <j-image-upload class='avatar-uploader' :text="$t('label.upload')" v-model='fileList'></j-image-upload>
        </mtc-form-item>
        <mtc-form-item label='label.birthday' :labelCol='labelCol' :wrapperCol='wrapperCol'>
          <a-date-picker style='width: 100%'
                         :placeholder="$t('label.pleaseSelectYourBirthday')"
                         v-decorator="['birthday', { initialValue: !model.birthday ? null : moment(model.birthday, dateFormat) }]"
                         :getCalendarContainer='(node) => node.parentNode' />
        </mtc-form-item>
        <mtc-form-item label='label.gender' :labelCol='labelCol' :wrapperCol='wrapperCol'>
          <a-select v-decorator="['sex', {}]"
                    showSearch
                    :placeholder="$t('label.pleaseSelectGender')"
                    :getPopupContainer='(target) => target.parentNode'>
            <a-select-option :value='1'>{{ $t('label.male') }}</a-select-option>
            <a-select-option :value='2'>{{ $t('label.female') }}</a-select-option>
          </a-select>
        </mtc-form-item>
        <mtc-form-item label='label.eMail' :labelCol='labelCol' :wrapperCol='wrapperCol'>
          <a-input :placeholder="$t('label.pleaseEnterYourEmailAddress')" v-decorator="['email', validatorRules.email]" />
        </mtc-form-item>
        <mtc-form-item label='label.cellPhone' :labelCol='labelCol' :wrapperCol='wrapperCol'>
          <a-input :placeholder="$t('label.pleaseEnterYourCellPhone')"
                   :disabled="isDisabledAuth('user:form:phone')"
                   v-decorator="['phone', validatorRules.phone]" />
        </mtc-form-item>
        <mtc-form-item label='label.phoneNumber' :labelCol='labelCol' :wrapperCol='wrapperCol'>
          <a-input :placeholder="$t('label.pleaseEnterTelephone')" v-decorator="['telephone', validatorRules.telephone]" />
        </mtc-form-item>
        <mtc-form-item label='label.workflowEngine' :labelCol='labelCol' :wrapperCol='wrapperCol'>
          <j-dict-select-tag v-decorator="['activitiSync', {}]"
                             :placeholder="$t('label.pleaseSelectWhetherSynchronizeWorkflowEngine')"
                             :type="'radio'"
                             :triggerChange='true'
                             dictCode='activiti_sync' />
        </mtc-form-item>
      </a-form>
    </a-spin>
    <depart-window ref='departWindow' :loadTree="treeUrl" @ok='modalFormOk' />
    <div class='drawer-bootom-button' v-show='!disableSubmit'>
      <a-popconfirm :title="$t('tip.sureToAbandonEditing')"
                    @confirm='close'
                    :okText="$t('button.confirm')"
                    :cancelText="$t('button.cancel')">
        <!--<a-button style="margin-right: 0.8rem">{{ $t('button.cancel') }}</a-button>-->
        <mtc-button style='margin-right: 0.8rem' text='button.cancel'></mtc-button>
      </a-popconfirm>
      <!--<a-button @click="handleSubmit" type="primary" :loading="confirmLoading">{{$t('button.submit')}}</a-button>-->
      <mtc-button @click='handleSubmit' type='primary' :loading='confirmLoading' text='button.submit'></mtc-button>
    </div>
    <mtc-lang-modal />
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick'
import moment from 'moment'
import Vue from 'vue'
import departWindow from './DepartWindow'
import JSelectPosition from '@/components/jeecgbiz/JSelectPosition'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getAction } from '@/api/manage'
import { addUser, editUser, queryUserRole, queryall, fileUpload, userDepartList, queryFiledLanguageList, queryMyDepartTreeList, queryIdTree } from '@/api/api'
import { disabledAuthFilter } from '@/utils/authFilter'
import { duplicateCheck } from '@/api/api'
import JImageUpload from '../../../components/jeecg/JImageUpload'
import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'
import { MTC_AUTH } from '@api/servers'
import { mapGetters } from 'vuex'
import langInputMixin from '@/mixins/langInputMixin'
import { resetLangFieldMap, setLangInputParams } from '@/utils/langUtils'

export default {
  name: 'UserModal',
  mixins: [mtcLangModalMixin, langInputMixin],
  components: {
    JImageUpload,
    departWindow,
    JSelectPosition
  },
  data(){
    return {
      // 当前页面唯一标识，用来获取新增编辑时的多语言字段
      mainTable: 'sys_user',
      departDisabled: false, //是否是我的部门调用该页面
      roleDisabled: false, //是否是角色维护调用该页面
      modaltoggleFlag: true,
      confirmDirty: false,
      selectedDepartKeys: [], //保存用户选择部门id
      checkedDepartKeys: [],
      checkedDepartNames: [], // 保存部门的名称 =>title
      checkedDepartNameString: '', // 保存部门的名称 =>title
      belongOrgId:'',
      resultDepartOptions: [],
      BelongDepartOptions:[],
      userId: '', //保存用户id
      disableSubmit: false,
      userDepartModel: { userId: '', departIdList: [] }, // 保存SysUserDepart的用户部门中间表数据需要的对象
      dateFormat: 'YYYY-MM-DD',
      validatorRules: {
        username: {
          rules: [
            {
              required: true,
              message: this.$t('label.pleaseEnterAccount')
            },
            {
              validator: this.validateUsername
            }]
        },
        password: {
          rules: [
            {
              required: true,
              pattern:/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/,
              message: '密码由8位数字、大小写字母和特殊符号组成!'
            },
            {
              validator: this.validateToNextPassword
            }
          ]
        },
        confirmpassword: {
          rules: [
            {
              required: true,
              message: this.$t('label.pleaseConfirmLoginPassword')
            },
            {
              validator: this.compareToFirstPassword
            }]
        },
        realname: { rules: [{ required: true, message: this.$t('label.pleaseEnterUsername') }] },
        phone: { rules: [{ validator: this.validatePhone }] },
        email: {
          rules: [
            {
              validator: this.validateEmail
            }
          ]
        },
        roles: {},
        //  sex:{initialValue:((!this.model.sex)?"": (this.model.sex+""))}
        workNo: {
          rules: [{ required: true, message: this.$t('label.pleaseEnterWorkNumber') }, { validator: this.validateWorkNo }]
        },
        telephone: {
          rules: [{ pattern: /^0\d{2,3}-[1-9]\d{6,7}$/, message: this.$t('label.pleaseEnterCorrectTelNumber') }]
        }
      },
      departIdShow: false,
      belongIdShow: false,
      departIds: [], //负责部门id
      title: '操作',
      visible: false,
      model: {},
      roleList: [],
      selectedRole: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      uploadLoading: false,
      confirmLoading: false,
      headers: {},
      // form:this.$form.createForm(this),
      picUrl: '',
      url: {
        // 引入为指定用户查看部门信息需要的url
        userWithDepart: `${ MTC_AUTH }sys/user/userDepartList`,
        // 引入生成添加用户情况下的url
        userId: `${ MTC_AUTH }sys/user/generateUserId`,
        // 同步用户到工作流
        syncUserByUserName: `${ MTC_AUTH }act/process/extActProcess/doSyncUserByUserName`,
        queryTenantList: `${ MTC_AUTH }sys/tenant/queryList`
      },
      identity: '1',
      fileList: [],
      tenantList: [],
      currentTenant: []
    }
  },
  computed: {
    ...mapGetters(['langFieldMap']),
    uploadAction(){
      return fileUpload
    },
    treeUrl() {
      if(this.departDisabled) return queryMyDepartTreeList
      return queryIdTree
    }
  },
  created(){
    const token = Vue.ls.get(ACCESS_TOKEN)
    this.headers = { 'X-Access-Token': token }
    this.initTenantList()
    this.initialAuthDeptList()

  },
  watch: {
    // checkedDepartNameString: function(newVal,oldVal){
    //   if(newVal!=='') this.belongIdShow=true
    //   else this.belongIdShow=false
    // }
  },
  methods: {
    moment,
    // 判断字段是否为必填字段
    checkFieldRequired( field ){
      if (!field || !this.validatorRules[ field ]) return false
      let ruleArr = this.validatorRules[ field ].rules
      return ruleArr.some(ele => ele.required && ele.required === true)
    },
    isDisabledAuth( code ){
      return disabledAuthFilter(code)
    },
    initTenantList(){
      getAction(this.url.queryTenantList).then(res => {
        if (res.success) {
          this.tenantList = res.result
        }
      })
    },
    initialAuthDeptList(){
      let depart=[]
      queryMyDepartTreeList().then(( res ) => {
        if(!res?.result) return
        if (res.success) {
          this.initialSubAuthDept(res.result,depart)
          this.BelongDepartOptions=depart
        } else {
          console.log(res.message)
        }
      })
    },
    initialSubAuthDept(sourceDepart,destlist)
    {
      for (let i = 0; i < sourceDepart?.length; i++) {
        var blank='';
        var num=parseInt(sourceDepart[i].orgCategory)
        for(let j = 0;j < num; j++) blank+='　'
        destlist.push({
            key: sourceDepart[ i ].key,
            title: blank+sourceDepart[ i ].title
          })
          if(sourceDepart[i].isLeaf)continue;
          this.initialSubAuthDept(sourceDepart[i].children,destlist)
      }
    },
    initialRoleList(){
      queryall().then(( res ) => {
        if (res.success) {
          this.roleList = res.result
        } else {
          console.log(res.message)
        }
      })
    },
    loadUserRoles( userid ){
      queryUserRole({ userid: userid }).then(( res ) => {
        if(res.result) this.selectedRole = res.result || []
      })
    },
    refresh(){
      this.selectedDepartKeys = []
      this.checkedDepartKeys = []
      this.checkedDepartNames = []
      this.checkedDepartNameString = ''
      // this.belongOrgId=''
      this.userId = ''
      this.resultDepartOptions = []
      this.BelongDepartOptions= []
      this.departId = []
      this.departIdShow = false
      this.currentTenant = []
    },
    add(){
      this.picUrl = ''
      this.refresh()
      this.edit({ activitiSync: '1' })
    },
    // 打开编辑模态框
    edit( record ){
      this.disableSubmit = false
      this.belongIdShow = true
      this.getLangForm(this.mainTable)
      this.initialRoleList()
      this.initialAuthDeptList()
      this.checkedDepartNameString = ''
      this.belongOrgId=''
      this.form.resetFields()
      if (record.hasOwnProperty('id')) {
        this.loadUserRoles(record.id)
        setTimeout(() => {
          this.fileList = record.avatar
        }, 5)
      }
      this.userId = record.id
      this.model = Object.assign({}, record)
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'username', 'sex', 'realname', 'email', 'phone', 'activitiSync', 'workNo', 'telephone', 'post'))
      })
      //身份为上级显示负责部门，否则不显示
      if (this.model.userIdentity == '2') {
        this.identity = '2'
        this.departIdShow = true
      } else {
        this.identity = '1'
        this.departIdShow = false
      }
      // 调用查询用户对应的部门信息的方法
      this.checkedDepartKeys = []
      this.loadCheckedDeparts()
      if (!record.relTenantIds || record.relTenantIds.length == 0) {
        this.currentTenant = []
      } else {
        this.currentTenant = record.relTenantIds.split(',') || []
      }
      this.belongOrgId=this.model.belongOrg
      this.visible = true
    },
    loadCheckedDeparts(){
      if (!this.userId) return
      userDepartList({ userId: this.userId }).then(( res ) => {
        if(!res?.result) return
        this.checkedDepartNames = []
        let depart = []
        let departId = []
        for (let i = 0; i < res?.result.length; i++) {
          this.checkedDepartNames.push(res.result[ i ].title)
          this.checkedDepartNameString = this.checkedDepartNames.join(',')
          this.checkedDepartKeys.push(res.result[ i ].key)
          //新增负责部门选择下拉框
          depart.push({
            key: res.result[ i ].key,
            title: res.result[ i ].title
          })
          departId.push(res.result[ i ].key)
        }
        this.resultDepartOptions = depart
        // this.BelongDepartOptions = depart
        //判断部门id是否存在，不存在择直接默认当前所在部门
        if (this.model.departIds) {
          this.departIds = this.model.departIds.split(',')
        } else {
          this.departIds = departId
        }
        this.userDepartModel.departIdList = this.checkedDepartKeys
      })
    },
    close(){
      this.$emit('close')
      this.visible = false
      this.disableSubmit = false
      this.selectedRole = []
      this.userDepartModel = { userId: '', departIdList: [] }
      this.checkedDepartNames = []
      this.checkedDepartNameString = ''
      this.checkedDepartKeys = []
      this.selectedDepartKeys = []
      this.resultDepartOptions = []
      this.BelongDepartOptions = []
      this.departIds = []
      this.departIdShow = false
      this.identity = '1'
      this.fileList = []
    },
    handleSubmit(){
      // 触发表单验证
      this.form.validateFields(( err, values ) => {
        if (!err) {
          if (!values.birthday) {
            values.birthday = ''
          } else {
            values.birthday = values.birthday.format(this.dateFormat)
          }
          let formData = Object.assign(this.model, values)
          if (this.fileList != '') {
            formData.avatar = this.fileList
          } else {
            formData.avatar = null
          }
          formData.relTenantIds = this.currentTenant.length > 0? this.currentTenant.toString(): ''
          formData.selectedroles = this.selectedRole.length > 0? this.selectedRole.toString(): ''
          formData.selecteddeparts = this.userDepartModel.departIdList.length > 0? this.userDepartModel.departIdList.toString(): ''
          formData.userIdentity = this.identity
          formData.belongOrg=this.belongOrgId
          if(this.departDisabled){
            // formData.belongOrg=this.userDepartModel.departIdList.length > 0? this.userDepartModel.departIdList.toString(): ''
          }
          //如果是上级择传入departIds,否则为空
          formData.departIds = this.identity === '2'? this.departIds.toString(): ''
          formData.id = this.userId || null
          // 设置数据多语言参数
          formData.sysLanguageList = setLangInputParams(this.mainTable, formData.id)
          let url = this.model.id? editUser: addUser
          this.confirmLoading = true
          url(formData).then(res => {
            resetLangFieldMap()
            this.$message.success(res?.message)
            this.$emit('ok')
          }).finally(() => {
            this.confirmLoading = false
            this.checkedDepartNames = []
            this.userDepartModel.departIdList = { userId: '', departIdList: [] }
            this.close()
          })
        }
      })
    },
    validateToNextPassword( rule, value, callback ){
      const form = this.form
      const confirmpassword = form.getFieldValue('confirmpassword')

      if (value && confirmpassword && value !== confirmpassword) {
        callback('两次输入的密码不一样！')
      }
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true })
      }
      callback()
    },
    compareToFirstPassword( rule, value, callback ){
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback('两次输入的密码不一样！')
      } else {
        callback()
      }
    },
    validatePhone( rule, value, callback ){
      if (!value) {
        callback()
      } else {
        //update-begin--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
        if (new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(value)) {
          //update-end--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------

          var params = {
            tableName: 'sys_user',
            fieldName: 'phone',
            fieldVal: value,
            dataId: this.userId
          }
          duplicateCheck(params).then(( res ) => {
            if (res.success) {
              callback()
            } else {
              callback('手机号已存在!')
            }
          })
        } else {
          callback('请输入正确格式的手机号码!')
        }
      }
    },
    validateEmail( rule, value, callback ){
      if (!value) {
        callback()
      } else {
        if (new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value)) {
          var params = {
            tableName: 'sys_user',
            fieldName: 'email',
            fieldVal: value,
            dataId: this.userId
          }
          duplicateCheck(params).then(( res ) => {
            console.log(res)
            if (res.success) {
              callback()
            } else {
              callback('邮箱已存在!')
            }
          })
        } else {
          callback('请输入正确格式的邮箱!')
        }
      }
    },
    validateUsername( rule, value, callback ){
      var params = {
        tableName: 'sys_user',
        fieldName: 'username',
        fieldVal: value,
        dataId: this.userId
      }
      duplicateCheck(params).then(res => {
        callback()
      }).catch(e => {
        callback(e.message)
      })
    },
    validateWorkNo( rule, value, callback ){
      var params = {
        tableName: 'sys_user',
        fieldName: 'work_no',
        fieldVal: value,
        dataId: this.userId
      }
      duplicateCheck(params).then(( res ) => {
        if (res.success) {
          callback()
        } else {
          callback('工号已存在!')
        }
      })
    },
    handleConfirmBlur( e ){
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    normFile( e ){
      console.log('Upload event:', e)
      if (Array.isArray(e)) {
        return e
      }
      return e && e.fileList
    },
    beforeUpload( file ){
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('tip.pleaseUploadAPicture'))
        return false
      }
      //TODO 验证文件大小
    },
    handleChange( info ){
      this.picUrl = ''
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        var response = info.file.response
        this.uploadLoading = false
        console.log(response)
        if (response.success) {
          this.model.avatar = response.message
          this.picUrl = 'Has no pic url yet'
        } else {
          this.$message.warning(response.message)
        }
      }
    },
    // 搜索用户对应的部门API
    onSearch(){
      this.$refs.departWindow.add(this.checkedDepartKeys, this.userId)
    },
    // 获取用户对应部门弹出框提交给返回的数据
    modalFormOk( formData ){
      console.log('%c [ formData ]', 'font-size:13px; background:pink; color:#bf2c9f;', formData)

      this.checkedDepartNames = this.checkedDepartNames || []
      this.selectedDepartKeys = this.userDepartModel.departIdList || []
      this.checkedDepartNameString = this.checkedDepartNameString || ''
      // this.userId = formData.userId
      this.userDepartModel.userId = formData.userId
      this.departIds = []
      var depart = []
      if (formData.departIdList && formData.departIdList.length) {
        this.checkedDepartNames = []
        this.selectedDepartKeys = []
        this.checkedDepartNameString = ''
        for (let i = 0; i < formData.departIdList.length; i++) {
          this.selectedDepartKeys.push(formData.departIdList[ i ].key)
          this.checkedDepartNames.push(formData.departIdList[ i ].title)
          this.checkedDepartNameString = this.checkedDepartNames.toString()
          //新增部门选择，如果上面部门选择后不为空直接付给负责部门
          depart.push({
            key: formData.departIdList[ i ].key,
            title: formData.departIdList[ i ].title
          })
          this.departIds.push(formData.departIdList[ i ].key)
        }
        this.resultDepartOptions = depart
        this.BelongDepartOptions = depart
      }
      this.userDepartModel.departIdList = this.selectedDepartKeys
      this.checkedDepartKeys = this.selectedDepartKeys  //更新当前的选择keys
    },
    identityChange( e ){
      if (e.target.value === '1') {
        this.departIdShow = false
      } else {
        this.departIdShow = true
      }
    }
  }
}
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}

.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>